<app-select-field [control]="customSelect" (onChange)="onChange($event)">

</app-select-field>
